var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control mb-2",attrs:{"type":"text","data-timepicker":"","placeholder":_vm._f("trans")(_vm.placeholder || 'Saat Seçin')},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }